import { render, staticRenderFns } from "./CalendarEventModal.vue?vue&type=template&id=385c07c3&scoped=true&"
import script from "./CalendarEventModal.vue?vue&type=script&lang=ts&"
export * from "./CalendarEventModal.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarEventModal.vue?vue&type=style&index=0&id=385c07c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385c07c3",
  null
  
)

export default component.exports